import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-symptom-assessment-intro',
  imports: [TranslateModule, RouterLink],
  templateUrl: './symptom-assessment-intro.component.html',
  styleUrl: './symptom-assessment-intro.component.scss',
})
export class SymptomAssessmentIntroComponent {}
